var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEssentials1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4127 17.8781L17.1377 20.8781C17.7471 21.2625 18.4971 20.6906 18.319 19.9875L16.9502 14.6063C16.9132 14.4571 16.9191 14.3005 16.9672 14.1546C17.0153 14.0086 17.1037 13.8792 17.2221 13.7813L21.4596 10.2469C22.0127 9.78752 21.7315 8.8594 21.0096 8.81252L15.4784 8.45627C15.3274 8.44749 15.1823 8.39494 15.0608 8.30503C14.9393 8.21513 14.8466 8.09177 14.794 7.95002L12.7315 2.75627C12.6769 2.60618 12.5774 2.47653 12.4466 2.38491C12.3158 2.29329 12.16 2.24414 12.0002 2.24414C11.8405 2.24414 11.6847 2.29329 11.5539 2.38491C11.423 2.47653 11.3236 2.60618 11.269 2.75627L9.20649 7.95002C9.15392 8.09177 9.06121 8.21513 8.93967 8.30503C8.81813 8.39494 8.67304 8.44749 8.52212 8.45627L2.99087 8.81252C2.26899 8.8594 1.98774 9.78752 2.54087 10.2469L6.77837 13.7813C6.8968 13.8792 6.98516 14.0086 7.03327 14.1546C7.08137 14.3005 7.08725 14.4571 7.05024 14.6063L5.78462 19.5938C5.56899 20.4375 6.46899 21.1219 7.19087 20.6625L11.5877 17.8781C11.711 17.7997 11.8541 17.7581 12.0002 17.7581C12.1464 17.7581 12.2894 17.7997 12.4127 17.8781V17.8781Z",
    fill: "#101828",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssentials1);
export default __webpack_public_path__ + "static/media/Essentials-1.b8d5f2f5ec1e2aa0d319f55d8284caa2.svg";
export { ForwardRef as ReactComponent };